import React, { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { cn } from '@/lib/utils';

// Every password field goes through here so each one has a show/hide toggle.
// `className` styles the <input> (like ui/Input); spacing such as `mt-1.5`
// goes on `containerClassName`, because the toggle centres on the wrapper.
const PasswordInput = forwardRef(function PasswordInput(
  { className, containerClassName, showLabel = 'Show password', hideLabel = 'Hide password', ...rest },
  ref,
) {
  const [shown, setShown] = useState(false);
  const testId = rest['data-testid'];
  const Icon = shown ? EyeOff : Eye;
  return (
    <div className={cn('relative', containerClassName)}>
      <Input ref={ref} type={shown ? 'text' : 'password'} className={cn('pr-10', className)} {...rest} />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? hideLabel : showLabel}
        aria-pressed={shown}
        title={shown ? hideLabel : showLabel}
        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-slate-400 hover:text-slate-600 focus-visible:outline-none focus-visible:text-slate-700"
        data-testid={testId ? `${testId}-toggle` : 'password-toggle'}
      >
        <Icon size={16} />
      </button>
    </div>
  );
});

export default PasswordInput;
